import { cn } from '../../lib/cn';
import type { SRERow } from '../../enterprisedevops/framework';

type Props = { metrics?: SRERow[] };

export function SREIncidentPanel({ metrics = [] }: Props) {
  return (
    <div className="space-y-2">
      {metrics.map((m) => (
        <div key={m.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{m.metric}</p>
              <p className="text-xs text-slate-500">target {m.target}</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold">{m.value}</p>
              <span className={cn(
                'text-xs font-medium',
                m.status === 'met' || m.status === 'healthy' || m.status === 'exceeded'
                  ? 'text-success-600' : 'text-error-600',
              )}>
                {m.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
